import { useI18n } from 'builder/hooks/useI18n'
import { SpinnerIndigo } from 'builder/components/Spinner'
import { TRANSLATION_KEY } from '../../constants'
import { ReviewFullSection } from '../../styles'
import loadingVideo from './assets/loading.webm'
import { Video, Description } from './styles'

export const AiResumeReviewLoader = () => {
  const { i18n } = useI18n()

  return (
    <ReviewFullSection data-testid="ai-resume-review-loader">
      <Video src={loadingVideo} autoPlay loop muted playsInline />
      <Description>
        <SpinnerIndigo $width="24px" $height="24px" />
        {i18n.t(`${TRANSLATION_KEY}.loader.description`)}
      </Description>
    </ReviewFullSection>
  )
}
